import {z} from 'zod';

import {CHART_LAYOUT_STORAGE_KEY} from '../constants/CHART_LAYOUT_STORAGE_KEY';
import type {ChartLayout} from '../types/ChartLayout';

const StoredChartLayoutSchema = z.record(z.string(), z.unknown());

const isHalfWidthEntry = (entry: [string, unknown]): entry is [string, 'half'] =>
  entry[1] === 'half';

/**
 * The stored chart layout, or the default layout when there is none or it cannot be read. An
 * entry with any other width is skipped, so it does not discard the valid half widths.
 */
export function readStoredChartLayout(): ChartLayout {
  try {
    const stored: unknown = JSON.parse(localStorage.getItem(CHART_LAYOUT_STORAGE_KEY) ?? '{}');
    const result = StoredChartLayoutSchema.safeParse(stored);
    return result.success
      ? Object.fromEntries(Object.entries(result.data).filter(isHalfWidthEntry))
      : {};
  } catch {
    return {};
  }
}
